<template>
  <!-- <div class="container reportDetail_reportItem" :ref='childRef'> -->
  <div class="container reportDetail_reportItem" ref='childRef'>
    <el-row style="margin-bottom:20px">
      <el-checkbox v-if="canPublish" :label="$t('storeFeedback.report.publish')" v-model="publishFlag"></el-checkbox>
      <el-button v-if="fcQuestionRemarksEdit" type="primary" @click="saveFcRemark">{{$t("common.save")}}</el-button>
      <el-button v-if="value.canEdit && status!='suspend'" type="primary" v-acl="Feedback-reportsSave" @click="save">{{$t('visitPlan.draftSave')}}</el-button>
      <el-button v-if="value.canChangeLevel && status!='suspend'" type="primary" v-acl="Feedback-changeReportAfterApprove" @click="changeLevel">{{$t("common.save")}}</el-button>
      <el-button v-if="value.canEdit && status!='suspend'" type="primary" v-acl="Feedback-reportsSave" @click="submit('reportForm')">
        {{$t("common.submit")}}
      </el-button>
      <template v-if="value.canEdit && status!='suspend'" v-acl="Feedback-reportsSave">
        <br />
        <label style="font-size:12px;color:#F56C6C;clear: both">{{$t('visitPlan.operationTips')}}</label>
      </template>
    </el-row>
    <el-form :model="feedbackReport" ref="reportForm" label-position="right" inline label-width="255px" :rules="feedbackReportRules">
      <el-card>
        <el-form-item :label="$t('storeFeedback.report.feedbackNo')">
          <el-input :value="feedbackHead.feedbackNo" disabled clearable></el-input>
        </el-form-item>
        <template v-if='!value.canEdit'>
          <el-form-item :label="$t('storeFeedback.feedbackStatus')">
            <!--问题报告状态  新增  的时候不要显示 -->
            <el-input :value="currentNodeName" disabled clearable></el-input>
          </el-form-item>
        </template>
        <el-form-item :label="$t('storeFeedback.report.reportNo')">
          <el-input :value="feedbackReport.reportNo" placeholder="保存后生成" disabled clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('storeFeedback.report.reportType')" prop="reportType">
          <!-- 调查报告类型 -->
          <IcSelect table="TT_FEEDBACK_REPORT" field="REPORT_TYPE" v-model="feedbackReport.reportType" clearable :disabled="!feedbackReport.canEdit || status=='suspend'"></IcSelect>
        </el-form-item>
        <template v-if='!value.canEdit'>
          <el-form-item :label="$t('storeFeedback.report.haveInterrogativeCommunication')">
            <!-- 是否发起疑问沟通 -->
            <el-input :value="!!feedbackReport.answer?'Y':'N'|ic('COMMON','YES_NO')" disabled clearable></el-input>
          </el-form-item>
        </template>
        <template v-if='!value.canEdit'>
          <el-form-item :label="$t('storeFeedback.report.doubtCommunicationStatus')">
            <!-- 疑问沟通状态 -->
            <el-input :value="feedbackReport.answerStatus|ic('TT_FEEDBACK_REPORT','QUESTION_STATUS')" disabled clearable></el-input>
          </el-form-item>
        </template>
        <template v-if='isMCD'>
          <el-form-item :label="$t('storeFeedback.report.storeTime')">
            <!-- 门店花费时间(小时) -->
            <el-input :value="(feedbackReport.storeOperateTime/1).toFixed(2)" disabled clearable></el-input>
          </el-form-item>
        </template>
        <template v-if='isMCD || isFBC'>
          <el-form-item :label="$t('storeFeedback.report.fbcOperateTime')">
            <!-- Feedback center调查花费时间(小时)-->
            <el-input :value="(feedbackReport.fbcOperateTime/1).toFixed(2)" disabled clearable></el-input>
          </el-form-item>
        </template>
        <template v-if='isMCD'>
          <el-form-item :label="$t('storeFeedback.report.mcdOperateTime')">
            <!--CQS处理问题花费时间(小时)-->
            <el-input :value="(feedbackReport.mcdOperateTime/1).toFixed(2)" disabled clearable></el-input>
          </el-form-item>
        </template>
        <template v-if='isSUP || isMCD '>
          <el-form-item :label="$t('storeFeedback.supplierCostTime')">
            <!-- 供应商调查花费时间（小时） 供应商/MCD查看的时候有，新增时候没有-->
            <el-input :value="(feedbackReport.supOperateTime/1).toFixed(2)" disabled clearable></el-input>
          </el-form-item>
        </template>
        <el-form-item :label="$t('storeFeedback.report.remark')" prop="reportRemark" class="widthReset" v-if="!isStore">
          <el-input type="textarea" autosize v-model="feedbackReport.reportRemark" clearable :disabled="!feedbackReport.canEdit || status=='suspend'" maxlength="200"></el-input>
        </el-form-item>
      </el-card>
      <el-card class="autoWidth" v-if='isStore'>
        <!-- 调查分析简报（反馈中心）-->
        <div slot="header"><span>{{$t("storeFeedback.report.CQSAnalysis")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')" prop='cqsAnalysis'>
              <el-input type="textarea" autosize v-model="feedbackReport.cqsAnalysis" :disabled="!feedbackReport.canAudit" clearable maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="autoWidth" v-if='isStore && feedbackReport.publishRemark'>
        <!-- 调查分析简报（McD）只有fbc并且不是审批的时候显示-->
        <div slot="header"><span>{{$t("storeFeedback.report.publishAnalysis")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.publishAnalysis')">
              <el-input type="textarea" autosize v-model="feedbackReport.publishRemark" disabled clearable maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card>
        <!-- 基本信息 -->
        <div slot="header" class="clearfix">
          <span>{{$t("storeFeedback.report.basicInfo")}}</span>
        </div>
        <el-form-item :label="$t('storeFeedback.report.receiveDate')">
          <!-- 接到反馈日期 -->
          <el-input :value="feedbackReport.receiveDate|dateFormatFilter('YYYY-MM-DD')" disabled clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('storeFeedback.report.problemLevel')">
          <!-- 投诉问题类别 -->
          <ic-select table="TT_FEEDBACK_FIRST_CHECK" field="PROBLEM_LEVEL" v-model="feedbackReport.feedbackLevel" :disabled="!feedbackReport.canChangeLevel"></ic-select>
        </el-form-item>
        <el-form-item :label="$t('storeFeedback.report.deadline')" v-if="!isStore">
          <!-- 初次最晚提交时间 -->
          <el-input :value="feedbackReport.reportDeadline|dateFormatFilter('YYYY-MM-DD HH:mm:ss')" disabled clearable></el-input>
          <!-- <el-date-picker :value="feedbackReport.reportDeadline|dateFormatFilter('YYYY-MM-DD HH:mm:ss')" type="datetime"  disabled clearable ></el-date-picker> -->
        </el-form-item>
        <el-form-item :label="$t('storeFeedback.report.haveRejected')" v-if="!isStore">
          <!-- 是否被CQS退回过 -->
          <el-input v-if='feedbackReport.haveRejectedByCqs' :value="feedbackReport.haveRejectedByCqs|ic('COMMON','YES_NO')" disabled clearable></el-input>
          <el-input v-else value="否" disabled clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('storeFeedback.report.canContinue')" prop="canContinue">
          <!--能否继续使用-->
          <IcSelect table="COMMON" field="YES_NO" v-model="feedbackReport.canContinue" clearable :disabled="!feedbackReport.canEdit || status=='suspend'"></IcSelect>
        </el-form-item>
        <el-form-item :label="$t('storeFeedback.report.sampleHandleMethod')" prop="sampleHandleMethod">
          <!--留样处理-->
          <ic-select v-model="feedbackReport.sampleHandleMethod" table="TT_FEEDBACK_REPORT" field="SAMPLE_HANDLE_METHOD" clearable :disabled="!feedbackReport.canEdit || status=='suspend'"></ic-select>
        </el-form-item>
        <el-form-item :label="$t('storeFeedback.report.responsibleParty')" prop="responsibleParty">
          <!--责任方-->
          <ic-select v-model="feedbackReport.responsibleParty" :table-fields="responsiblePartyField" clearable :disabled="!feedbackReport.canEdit || status=='suspend'"></ic-select>
        </el-form-item>
        <el-form-item :label="$t('storeFeedback.report.needDebit')" prop="needDebit">
          <!--是否扣账-->
          <el-select v-model="feedbackReport.needDebit" @change='needDebitChange' clearable :disabled="!feedbackReport.canEdit || status=='suspend'">
            <el-option value="Y" label="是">是</el-option>
            <el-option value="N" label="否">否</el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('storeFeedback.report.debitNumber')" prop="debitNumber" :rules="isneedDebit ? feedbackReportRules.debitNumber : feedbackReportRules.debitNumber2">
          <!--扣账数量-->
          <el-input onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" @blur="debitNumberBlur" v-model="feedbackReport.debitNumber" clearable :disabled="!feedbackReport.canEdit || !isneedDebit" maxLength='9'></el-input>
        </el-form-item>
        <!--                <el-form-item :label="$t('storeFeedback.report.debitUnit')" prop="debitUnit" :rules="isneedDebit ? feedbackReportRules.debitUnit : feedbackReportRules.debitUnit2">&lt;!&ndash;扣账数量单位&ndash;&gt;
                    <ic-select v-model="feedbackReport.debitUnit" table="TT_FEEDBACK" field="UNIT" clearable :disabled="!feedbackReport.canEdit || !isneedDebit"></ic-select>
                </el-form-item>-->
        <el-form-item :label="$t('storeFeedback.report.debitUnit')" prop="debitUnit">
          <!--扣账数量单位-->
          <el-input v-model="feedbackReport.debitUnitI18n" clearable :disabled="true"></el-input>
        </el-form-item>
      </el-card>
      <el-card class="autoWidth">
        <!--详细调查报告-->
        <div slot="header" class="clearfix"><span>{{$t("storeFeedback.report.reportDetail")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')" prop="reportDetail">
              <!--描述-->
              <el-input type="textarea" maxlength="10000" autosize v-model="feedbackReport.reportDetail" clearable :disabled="!feedbackReport.canEdit || status=='suspend'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.DocAttachment')" prop="reportDetailDoc">
              <el-table :data="feedbackReport.reportDetailDoc" border highlight-current-row class="tableFile">
                <el-table-column sortable prop="documentName" :label="$t('common.file')">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="tmDocumentId" min-width="130px" v-if="value.canEdit">
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,feedbackReport.reportDetailDoc)">{{$t('common.del')}}</el-link>
                    <!--删除-->
                  </template>
                </el-table-column>
              </el-table>
              <el-upload v-if="feedbackReport.canEdit && status!='suspend'" ref="reportDetailDoc" action="upload" :http-request="reportDetailDocUpload" multiple :on-remove="reportDetailDocRemove" :before-upload="reportDetailBeforeUpload" show-file-list="false" name="file">
                <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.PicAttachment')" prop="reportDetailImg">
              <el-upload :headers="header" :action="fileUploadUrl" :class="{hide:!feedbackReport.canEdit}" :disabled="!feedbackReport.canEdit" class="reportDetailImgClass" ref="reportDetailImg" :show-file-list="true" :on-success="reportDetailImgUpload" multiple :file-list="reportDetailImg" :before-remove="reportDetailImgBeforeRemove" :on-preview="reportDetailImgPreview" list-type="picture-card" name="file" :on-change="reportDetailImgChange" :before-upload="reportDetailImgBeforeUpload" accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP">
                <!-- <el-progress v-if="progressFlag" :percentage="loadProgress" type="circle"></el-progress> -->
                <i class="el-icon-plus"></i>

                <div slot="file" slot-scope="{file}">
                  <!-- {{file}} -->
                  <template>
                    <el-input v-model="file.docComments" clearable :disabled="!feedbackReport.canEdit" @input="miaoahuChange(file)" placeholder="请输入图片描述"></el-input>
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="reportDetailImgPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                        <i class="el-icon-download"></i>
                      </span>
                      <span v-if="feedbackReport.canEdit" class="el-upload-list__item-delete" @click="reportDetailImgRemove(file)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </template>

                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible" append-to-body class="enlargePhoto">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="autoWidth">
        <!-- 改进措施 -->
        <div slot="header"><span>{{$t("storeFeedback.report.treatment")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')">
              <el-input type="textarea" autosize v-model="feedbackReport.treatment" clearable :disabled="!feedbackReport.canEdit || status=='suspend'" maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.attachment')">
              <el-table :data="feedbackReport.treatmentDoc" border highlight-current-row class="tableFile">
                <el-table-column sortable prop="documentName" :label="$t('common.file')">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="tmDocumentId" min-width="130px" v-if="value.canEdit">
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,feedbackReport.treatmentDoc)">{{$t('common.del')}}</el-link>
                    <!--删除-->
                  </template>
                </el-table-column>
              </el-table>
              <el-upload v-if="feedbackReport.canEdit && status!='suspend'" ref="treatmentDoc" action="upload" :http-request="treatmentDocUpload" multiple :before-upload="treatmentBeforeUpload" :on-remove="treatmentDocRemove" show-file-list="false" name="file">
                <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="autoWidth" v-if='!isStore'>
        <!--调查分析简报（供应商） 门店人员不显示此内容 -->
        <div slot="header"><span>{{$t("storeFeedback.report.supplierAnalysis")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')" prop="supplierAnalysis">
              <el-input type="textarea" autosize v-model="feedbackReport.supplierAnalysis" clearable :disabled="!feedbackReport.canEdit || status=='suspend'" maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="autoWidth" v-if='!(value.canEdit || isFBC || isStore)'>
        <!-- 调查分析简报（反馈中心） 不显示：新增、反馈中心，显示：供应商查看、MCD查看 门店查看时候放在上面-->
        <div slot="header"><span>{{$t("storeFeedback.report.CQSAnalysis")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')" prop='cqsAnalysis'>
              <el-input type="textarea" autosize v-model="feedbackReport.cqsAnalysis" :disabled="!feedbackReport.canAudit" clearable maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="autoWidth" v-if='isFBC'>
        <!-- 调查分析简报（McD）只有fbc并且不是审批的时候显示-->
        <div slot="header"><span>{{$t("storeFeedback.report.FBCAnalysis")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')">
              <el-input type="textarea" autosize v-model="feedbackReport.cqsAnalysis" :disabled="!feedbackReport.canAudit" clearable maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="autoWidth" v-if='!isStore && feedbackReport.publishRemark'>
        <!-- 调查分析简报（McD）只有fbc并且不是审批的时候显示-->
        <div slot="header"><span>{{$t("storeFeedback.report.publishAnalysis")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.publishAnalysis')">
              <el-input type="textarea" autosize v-model="feedbackReport.publishRemark" disabled clearable maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card v-if="(feedbackReport.feedbackLevel=='A' || feedbackReport.feedbackLevel=='B') && feedbackReport.auditorSignId">
        <!--麦中供应链QS批准 审批通过后，且问题等级为AB类的才显示-->
        <div slot="header" class="clearfix"><span>{{$t("storeFeedback.report.sign")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-image style="width: 200px;height: 100px;" fit="contain" :src="HandleUrl(feedbackReport.auditorSignId)">
            </el-image>
          </el-col>
        </el-row>
      </el-card>
      <el-card v-if=" isMCD || isFBC || (isSUP &&  !isNew)">
        <!-- 审批日志 -->
        <div slot="header" class="clearfix"><span>{{$t("common.approvalLog")}}</span></div>
        <el-table :data="feedbackReport.logs" align="center" border highlight-current-row class="table">
          <el-table-column prop="createDate" :label="$t('common.OperationTime') ">
            <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}</template>
          </el-table-column>
          <el-table-column prop="operatorName" :label="$t('common.OperatorName') "></el-table-column>
          <el-table-column prop="action" :label="$t('common.PedagogicalOperation') "></el-table-column>
          <el-table-column prop="comments" :label="$t('common.opinion') ">
            <template slot-scope="scope">
              <div style="white-space: pre-wrap;">{{scope.row.comments}}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-form>
    <el-form :model="feedbackReport" label-position="right" label-width="30%">
      <el-card class="autoWidth" v-if="(feedbackReport.question!=null && isStore) || (!isSUP && !isStore) ">
        <!-- 门店疑问 1. 供应商 看不到 2.门店角色：门店疑问和疑问回复两个模块，如果为空，则不显示 3. 原型上门店疑问不是必填 bug：2062要求必填 -->
        <span>{{$t("storeFeedback.report.questionOfStore")}}</span>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')">
              <!-- <el-input type="textarea" autosize v-model="feedbackReport.question" :disabled="!feedbackReport.canAsk"></el-input> -->
              <el-input type="textarea" autosize v-model="feedbackReport.question" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.attachment')">
              <el-table :data="feedbackReport.questionDoc" border highlight-current-row class="tableFile">
                <el-table-column sortable prop="documentName" :label="$t('common.file')">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <store-feedback-attachments :docList.sync="feedbackReport.questionDoc" :img-list.sync="feedbackReport.questionImg" :disabled="!feedbackReport.canAsk"></store-feedback-attachments> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="autoWidth" v-if="(feedbackReport.answer!=null && isStore) || (!isSUP && !isStore)">
        <!-- 疑问回复-->
        <div slot="header"><span>{{$t("storeFeedback.report.answerOfFBC")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')">
              <el-input type="textarea" maxlength="1000" autosize v-model="feedbackReport.answer" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.attachment')">
              <el-table :data="feedbackReport.answerDoc" border highlight-current-row class="tableFile">
                <el-table-column sortable prop="documentName" :label="$t('common.file')">
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <el-upload
                                v-if="feedbackReport.canAnswer"
                                ref="answerDoc"
                                action="upload"
                                :http-request="answerDocUpload"
                                multiple
                                :on-remove="answerDocRemove"
                                show-file-list="false"
                                name="file"
                                >
                                <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
                            </el-upload> -->
            </el-form-item>
          </el-col>
          <!--FC疑问备注-->
          <el-col v-if="(!isSUP && !isStore)" :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.fcQuestionRemarks')">
              <el-input type="textarea" autosize v-model="feedbackReport.fcQuestionRemarks" :disabled="!fcQuestionRemarksEdit"></el-input>
            </el-form-item>
          </el-col>
          <!--FC疑问附件-->
          <el-col v-if="(!isSUP && !isStore)" :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.fcAnnex')" class="widthReset">
              <el-upload v-show="fcQuestionRemarksEdit" style="float:left" ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
                <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
                <!--选取文件-->
              </el-upload>
              <el-table :data="fcFileList" border highlight-current-row class="table">
                <el-table-column sortable prop="documentName" :label="$t('common.file')" min-width="130px">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
                <!--创建人-->
                <el-table-column sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
                  <!--创建时间-->
                  <template slot-scope="scope">
                    {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
                  </template>
                </el-table-column>

                <el-table-column prop="tmDocumentId" min-width="130px">
                  <template slot-scope="scope">
                    <el-link v-show="fcQuestionRemarksEdit" type="primary" @click.native.prevent="deleteFcFile(scope.row.tmDocumentId,scope.$index,fcFileList)">{{$t('common.del')}}</el-link>
                    <!--删除-->
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>

        </el-row>
      </el-card>
    </el-form>
    <!-- 没值的时候一直显示 疑问沟通按钮 -->
    <el-tooltip v-acl="Feedback-reportsQuestion" class="item" effect="dark" content="如您对问题报告还有其它意见，请在5天内点击疑问沟通反馈" placement="top-start" v-if="!feedbackReport.question && status!='suspend' && isStore">
      <el-button type="primary" @click="showQuestionFun">{{$t('storeFeedback.report.doubtCommunication')}}</el-button>
    </el-tooltip>
    <el-dialog :title="$t('storeFeedback.report.doubtCommunication')" :visible.sync="questionDialogVisible" width="60%">
      <el-form :model="feedbackReport" ref="questionForm" label-position="right" label-width="20%" :rules="questionFormRules">
        <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')" prop="question">
          <!-- 门店疑问 -->
          <el-input type="textarea" autosize v-model="feedbackReport.question"></el-input>
        </el-form-item>
        <el-form-item label-width="15%" :label="$t('storeFeedback.report.attachment')" prop="questionDoc">
          <el-upload ref="questionDoc" action="upload" :http-request="questionDocUpload" multiple :on-remove="questionDocRemove" show-file-list="false" name="file">
            <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="questionDialogVisible = false">{{$t("common.cancel")}}</el-button>
        <el-button type="primary" @click="questionSubmit">{{$t("common.submit")}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Watermark from '@/utils/watermark';
import reportApi from "@/api/storeFeedback/report";
import IcSelect from "@/components/common/icSelect";
import FileList from "@/components/common/fileList";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import StoreFeedbackAttachments from "@/components/page/storeFeedback/storeFeedbackAttachments";
import { fileService } from "@/api/common/file-utils";
import commonConstatns from "@/constants/commonConstants"
import { storeService } from "@/api/base-data/store";
export default {
  name: "report-detail_report-item",
  components: { StoreFeedbackAttachments, FileList, IcSelect },
  props: {
    childRef: Object,
    value: Object,
    feedback: Object,
    disabled: String,
  },
  data() {
    var reportDetailDocValidator = (rule, value, callback) => {
      if (this.feedbackReport.reportDetailDoc.length == 0)
        if (this.reportDetailDoc2.length == 0) {
          callback(new Error(this.$t("storeFeedback.report.uploadFile")));
        } else {
          callback();
        }
      else {
        callback();
      }
    };
    var questionValidator = (rule, value, callback) => {
      if (this.questionDoc2.length == 0)
        callback(new Error(this.$t("storeFeedback.report.uploadFile")));
      else {
        callback();
      }
    };
    var answerDocValidator = (rule, value, callback) => {
      if (this.feedbackReport.answerDoc.length == 0) {
        if (this.answerDoc2.length == 0) {
          callback(new Error(this.$t("storeFeedback.report.uploadFile")));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      canPublish: false,
      publishFlag: false,
      loadProgress: 0, // 动态显示进度条
      progressFlag: false,
      fileUploadUrl: commonConstatns.fileUploadUrl,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      dialogImageUrl: '',
      dialogVisible: false,
      emplid: '',
      questionDialogVisible: false,//疑问沟通弹框
      isNew: false,
      isStore: false,
      isFBC: false,
      isMCD: false,
      isSUP: false,
      taskApproval: false,
      reportDetailDoc: [],//详细调查报告
      reportDetailDoc2: [],
      reportDetailImg: [],//详细调查报告  图片
      reportDetailImg2: [],
      treatmentDoc: [],//改进措施
      treatmentDoc2: [],
      questionDoc: [],//门店疑问
      questionDoc2: [],
      answerDoc: [],//疑问回复
      answerDoc2: [],
      disableQuestion: false,
      showQuestion: true,
      feedbackHead: this.feedback.feedback,
      feedbackReport: this.value,
      feedbackFirstCheck: this.feedback.feedbackFirstCheck,
      isneedDebit: false,
      fcFileList: [],
      fcQuestionRemarksEdit: false,
      feedbackReportRules: {
        reportType: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: ["change", "blur"] },
        ],
        canContinue: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: ["change", "blur"] },
        ],
        sampleHandleMethod: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "change" },
        ],
        responsibleParty: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "change" },
        ],
        needDebit: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "change" },
        ],
        debitNumber: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        debitNumber2: [
          { required: false }
        ],
        /*                    debitUnit: [
                                { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "change"},
                            ],
                            debitUnit2: [
                                { required: false}
                            ],*/
        reportDetail: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        // reportDetailDoc:[{ required: true, validator: reportDetailDocValidator,trigger: 'change' }],
        supplierAnalysis: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
        cqsAnalysis: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
        answer: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
        answerDoc: [{ required: true, validator: answerDocValidator, trigger: 'change' }],

      },
      questionFormRules: {
        question: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
        // questionDoc:[{ required: true, validator: questionValidator,trigger: 'change' }],
      },
      nodeList: [],
      status: '',
      boxText: this.$t("storeFeedback.report.box")
    }
  },
  created() {
    this.emplid = localStorage.getItem('emplid');
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    let emplFlag = localStorage.getItem('ms_emplFlag');
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'SF_STORE_BASIC') {//门店
        this.isStore = true;
      }
      if (roles[i] == 'SF_FBC_BASIC') {//反馈中心
        this.isFBC = true;
      }
      if (roles[i] == 'SF_MCD_BASIC') {//麦当劳
        this.isMCD = true;
      }
    }
    if (emplFlag == "SUP") {//供应商
      this.isSUP = true;
    }
    if (this.$route.query.action) {
      let action = this.$route.query.action;
      if (action == 'create') {
        this.isNew = true
      } else {
        this.isNew = false
      }
    }
  },
  mounted() {
    this.getData();

    this.$nextTick(() => {
      let auditorSignId = this.feedbackReport.auditorSignId
      if (auditorSignId) {
        Watermark.set(this.emplid, this.$refs.childRef)
      }

      // Watermark.set('水印水印', this.$refs[`directrecordwp${0}`])
      // Watermark.set('水印水印', this.$refs[`directrecordwp${1}`])
    })
  },
  computed: {
    currentNodeName() {
      if (this.feedback.feedback.workflowStatus == 'suspend') {
        return "已中止";
      } else {
        return this.feedback.nodeList.filter(node => node.status == 'current')[0].nodeName;
      }
    },
    responsiblePartyField() {
      if (commonFun.isNotEmpty(this.feedbackReport.supplierType)) {
        if (this.feedbackReport.supplierType == "DC" || this.feedbackReport.supplierType == "CARRIER") {
          return [{ table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_DC" }];
        } else if (this.feedbackReport.supplierType == 'PLANT' || this.feedbackReport.supplierType == 'SUPPLIER') {
          return [{ table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_SUP" }];
        }
      } else {
        return [{ table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_DC" }, { table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_SUP" }];
      }
    },
    dataChanged() {
      let { value, feedback } = { value: this.value, feedback: this.feedback };
      return { value, feedback };
    },
    haveQuestion() {
      return !!this.feedbackReport.question ? 'Y' : 'N';
    },
    questionStatus() {
      if (commonFun.isEmpty(this.feedbackReport.question)) {
        return "NO_QUESTION";
        // return " ";
      } else {
        if (commonFun.isEmpty(this.feedbackReport.answer)) {
          return "PENDIND";
        } else {
          return "ANSWERED";
        }
      }
    },

  },
  methods: {
    getData() {
      let action = this.$route.query.action;
      this.feedbackHead = this.feedback.feedback;
      this.nodeList = this.feedback.nodeList
      let reportDetailImg = this.value.reportDetailImg
      if (reportDetailImg != null && reportDetailImg.length > 0) {
        var temp = reportDetailImg.map(function (item) {
          let obj = {
            name: item["documentName"],
            url: '/adminconsole/file/downloadByKey?key=' + item["documentKey"],
            docComments: item["docComments"],
            fullPath: item["fullPath"],
            tmDocumentId: item["tmDocumentId"],
            documentName: item["documentName"],
            downloadType: item["downloadType"]
          };
          return obj;
        });
        this.reportDetailImg = temp
        this.reportDetailImg2 = reportDetailImg
      }
      this.feedbackReport = this.value;
      this.canPublish = this.feedbackReport.canPublish;

      this.feedbackFirstCheck = this.feedback.feedbackFirstCheck;
      this.status = this.feedback.feedback.status;
      this.needDebitChange(this.feedbackReport.needDebit, true);
      if (!!this.feedbackReport.ttFeedbackReportId) {
        //调查结案，反馈中心，不能编辑其它项
        let roles = JSON.parse(localStorage.getItem("ms_roles"));
        if (roles.indexOf('SF_FBC_BASIC') != -1 && this.feedbackHead.workflowStatus == 'finalSettlement' && !(this.value.canChangeLevel && this.status != 'suspend')) {
          this.fcQuestionRemarksEdit = true;
        }
        this.getFcFiles();

      }
    },
    save() {
      let that = this;
      this.feedbackReport.reportDetailDoc = that.feedbackReport.reportDetailDoc.concat(that.reportDetailDoc2);
      this.feedbackReport.treatmentDoc = that.feedbackReport.treatmentDoc.concat(that.treatmentDoc2);
      this.feedbackReport.reportDetailImg = that.reportDetailImg2
      reportApi.save(this.feedbackReport).then(resp => {
        that.$refs.reportDetailDoc.clearFiles()
        that.$refs.treatmentDoc.clearFiles()
        that.reportDetailDoc2 = []
        that.treatmentDoc2 = []
        that.reportDetailImg2 = []
        if (resp.code != 200) {
          Message.error(resp.msg);
        } else {
          Message.success(that.$t("common.saveSuccess"));
          that.$router.replace({
            name: `feedbackReportView`,
            query: {
              feedbackId: resp.data.ttFeedbackId,
              feedbackReportId: resp.data.ttFeedbackReportId,
              timestamp: new Date().getTime()
            }
          })
        }
      })
    },
    changeLevel() {
      let that = this;
      reportApi.changeLevel(that.feedbackReport).then(resp => {
        Message.success(that.$t("common.updateSuccess"));
        that.$router.push({
          name: `feedbackReportView`,
          query: {
            feedbackId: that.feedbackReport.ttFeedbackId,
            feedbackReportId: that.feedbackReport.ttFeedbackReportId,
            timestamp: new Date().getTime()
          }
        })
      });
    },
    submit(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          for (let i = 0; i < that.reportDetailImg2.length; i++) {
            console.log(commonFun.isNotEmpty(that.reportDetailImg2[i].docComments))
            if (!commonFun.isNotEmpty(that.reportDetailImg2[i].docComments)) {
              that.$message({
                type: "error",
                message: "图片描述必填"
              });
              return;
            }
          }
          this.feedbackReport.auditStatus = 'SUBMIT';
          this.feedbackReport.reportDetailDoc = that.feedbackReport.reportDetailDoc.concat(that.reportDetailDoc2);
          this.feedbackReport.treatmentDoc = that.feedbackReport.treatmentDoc.concat(that.treatmentDoc2);
          this.feedbackReport.reportDetailImg = that.reportDetailImg2
          reportApi.save(this.feedbackReport).then(resp => {
            that.$refs.reportDetailDoc.clearFiles()
            that.$refs.treatmentDoc.clearFiles()
            that.reportDetailDoc2 = []
            that.treatmentDoc2 = []
            that.treatmentDoc2 = []
            if (resp.code != 200) {
              Message.error(resp.msg);
            } else {
              Message.success(that.$t("common.submitSuccess"));
              that.$router.push({//返回列表
                name: `feedbackReport`,
              })
            }
          })
        } else {
          return false;
        }
      });
    },
    questionSubmit() {
      let that = this;
      this.$refs.questionForm.validate(valid => {
        if (valid) {
          this.feedbackReport.auditStatus = 'SUBMIT';
          this.questionDialogVisible = false
          // this.feedbackReport.reportDetailDoc=that.feedbackReport.reportDetailDoc.concat(that.reportDetailDoc2) ;
          // this.feedbackReport.treatmentDoc=that.feedbackReport.treatmentDoc.concat(that.treatmentDoc2) ;
          this.feedbackReport.questionDoc = that.feedbackReport.questionDoc.concat(that.questionDoc2);
          console.log(this.feedbackReport)
          reportApi.save(this.feedbackReport).then(resp => {
            that.$refs.questionDoc.clearFiles()
            if (resp.code != 200) {
              Message.error(resp.msg);
            } else {
              Message.success(that.$t("common.submitSuccess"));
              that.$router.push({
                name: `feedbackReport`,
              })
            }
          })
        } else {
          return false;
        }
      });
    },
    audit(auditStatus) {
      let that = this;
      let promise = null;
      let feedbackReport = this.feedbackReport;
      feedbackReport.auditStatus = auditStatus;
      let option = {
        confirmButtonText: that.$t("common.confirm"),
        cancelButtonText: that.$t("common.cancel"),
        customClass: 'colorBtn',
        inputValidator: (value) => {
          if (auditStatus == 'UNJUDGEABLE') {
            return commonFun.isNotEmpty(value) ? true : that.$t("common.canNotBeEmpty")
          }
          if (auditStatus == 'REJECT') {
            return commonFun.isNotEmpty(value) ? true : that.$t("common.canNotBeEmpty")
          }
        }
      }
      if (auditStatus == 'REJECT') {
        promise = this.$prompt(that.$t("storeFeedback.report.pleaseFillInRejectReason"), that.$t("storeFeedback.report.auditReject"), option)
      } else if (auditStatus == 'PASS') {
        if (!feedbackReport.cqsAnalysis) {//通过时，调查分析简报（反馈中心）必须填写
          that.$refs.reportForm.validateField('cqsAnalysis');
          // Message.error(that.$t("storeFeedback.report.NoCQSAnalysis"));
          return;
        }
        promise = this.$prompt(that.$t("common.remarks"), that.$t("storeFeedback.report.auditPass"), option)
      } else if (auditStatus == 'UNJUDGEABLE') {//发送CQS
        promise = this.$prompt(that.$t("storeFeedback.report.pleaseReason"), option)
      }
      promise.then(res => {
        feedbackReport.auditRemark = res.value;
      }).then(value => {
        console.log(feedbackReport)
        reportApi.save(feedbackReport).then(resp => {
          if (resp.code != 200) {
            Message.error(resp.msg);
          } else {
            that.$message({
              message: that.$t("common.success"),
              type: "success"
            });
            that.$router.go(-1);
          }
        })
      }).catch(reason => {
        console.log(reason);
      })
    },
    reportDetailBeforeUpload(file) {
      let _this = this;
      const isJPG = file.type === "image/jpg";
      const isPng = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isGIF = file.type === "image/gif";
      const isBMP = file.type === "image/bmp";
      // accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
      if (isJPG || isPng || isJPEG || isGIF || isBMP) {
        _this.$message.error("不可以上传图片");
        return false;
      }
      if(file.name&&file.name.length>100) {
        _this.$message.error("附件名称过长，请修改后再传");
        return false;
      }
    },
    reportDetailImgChange(file, fileList) {
      // console.log(fileList)
      // console.log(this.reportDetailImg2)
      // console.log(this.reportDetailImg)
      // let _this = this;
      // const isJPG = file.raw.type === "image/jpg";
      // const isPng = file.raw.type === "image/png";
      // const isJPEG = file.raw.type === "image/jpeg";
      // const isGIF = file.raw.type === "image/gif";
      // const isBMP = file.raw.type === "image/bmp";
      //  if (!isJPG && !isPng && !isJPEG && !isGIF && !isBMP) {
      //     // _this.$refs.reportDetailImg.clearFiles();
      // }
    },
    reportDetailImgBeforeUpload(file) {
      // let _this = this;
      // const isJPG = file.type === "image/jpg";
      // const isPng = file.type === "image/png";
      // const isJPEG = file.type === "image/jpeg";
      // const isGIF = file.type === "image/gif";
      // const isBMP = file.type === "image/bmp";
      //  if (!isJPG && !isPng && !isJPEG && !isGIF && !isBMP) {
      //     this.$message.error("只能上传图片");
      //     console.log(this.reportDetailImg2)
      //     console.log(this.reportDetailImg)
      //     // return false
      // }
    },
    treatmentBeforeUpload(file) {
      let _this = this;
      if(file.name&&file.name.length>100) {
        _this.$message.error("附件名称过长，请修改后再传");
        return false;
      }
    },
    //详细调查报告 附件上传
    reportDetailDocUpload: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        _this.reportDetailDoc2.push(res.data[0])
        _this.$refs.reportForm.validateField('reportDetailDoc');
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //详细调查报告 图片上传
    reportDetailImgUpload: function (response, file, fileList) {
      // debugger
      //先判断是不是图片
      const isJPG = file.raw.type === "image/jpg";
      const isPng = file.raw.type === "image/png";
      const isJPEG = file.raw.type === "image/jpeg";
      const isGIF = file.raw.type === "image/gif";
      const isBMP = file.raw.type === "image/bmp";
      if (!isJPG && !isPng && !isJPEG && !isGIF && !isBMP) {
        fileList.pop()
        this.$message.error("只能上传图片");
      } else if(file.name&&file.name.length > 100) {
        fileList.pop()
        this.$message.error("附件名称过长，请修改后再传");
      } else {
        this.reportDetailImg2.push(response.data[0])
        // this.progressFlag = false;
        this.reportDetailImg.push(file)
        Message({ message: this.$t('common.UploadSucceed'), type: "success" });
      }

    },
    uploadProcess: function (event, file, fileList) {
      this.progressFlag = true; // 显示进度条
      this.loadProgress = file.percentage.toFixed(0);
    },
    miaoahuChange(value) {
      let that = this
      let fullPath = ''
      if (value.response) {
        fullPath = value.response.data[0].fullPath
      } else {
        fullPath = value.fullPath
      }

      for (let i = 0; i < that.reportDetailImg2.length; i++) {
        if (that.reportDetailImg2[i].fullPath == fullPath) {
          that.reportDetailImg2[i].docComments = value.docComments
        }
      }
    },
    reportDetailImgPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    reportDetailImgBeforeRemove() {
      return false;//解决键盘删除
    },
    reportDetailImgRemove(file) {
      let tmDocumentId = file.tmDocumentId
      let list = this.reportDetailImg2
      if (!file.raw) {
        fileService.deleteFile(tmDocumentId).then((res) => {
          //删除成功删除列表数据
          for (let j = 0; j < list.length; j++) {
            if (list[j].fullPath == file.fullPath) {
              list.splice(j, 1)
              this.reportDetailImg.splice(j, 1)
            }
          }
          this.reportDetailImg2 = list
        })
      } else {
        for (let j = 0; j < list.length; j++) {
          if (list[j].fullPath == file.response.data[0].fullPath) {
            list.splice(j, 1)
            this.reportDetailImg.splice(j, 1)
          }
        }

        this.reportDetailImg2 = list
      }

    },
    //详细调查报告删除(没保存前)
    reportDetailDocRemove(file) {
      for (let j = 0; j < this.reportDetailDoc2.length; j++) {
        if (this.reportDetailDoc2[j].documentName == file.name) {
          this.reportDetailDoc2.splice(j, 1)
        }
      }
    },
    //改进措施附件上传
    treatmentDocUpload: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        _this.treatmentDoc2.push(res.data[0])
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //改进措施 删除(没保存前)
    treatmentDocRemove(file) {
      for (let j = 0; j < this.treatmentDoc2.length; j++) {
        if (this.treatmentDoc2[j].documentName == file.name) {
          this.treatmentDoc2.splice(j, 1)
        }
      }
    },
    //疑问沟通附件上传
    questionDocUpload: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        _this.questionDoc2.push(res.data[0])
        _this.$refs.questionForm.validateField('questionDoc');
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //疑问沟通 删除(没保存前)
    questionDocRemove(file) {
      for (let j = 0; j < this.questionDoc2.length; j++) {
        if (this.questionDoc2[j].documentName == file.name) {
          this.questionDoc2.splice(j, 1)
        }
      }
    },
    //疑问回复 附件上传
    answerDocUpload: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        _this.questionDoc2.push(res.data[0])
        _this.$refs.questionForm.validateField('questionDoc');
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then(res => { });
    },

    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      let that = this
      fileService.deleteFile(tmDocumentId).then((res) => {
        this.$message({
          type: "success",
          message: this.$t("common.delSuccess"),
        });
        //删除成功删除列表数据
        files.splice(index, 1);
        that.getData()
      })
    },
    needDebitChange(val, initFlag) {
      if (initFlag) {//初始化显示原始值
        if (val == "Y") {
          this.isneedDebit = true
        } else {
          this.isneedDebit = false
          this.feedbackReport.debitNumber = 0
        }
      } else {
        if (val == "Y") {
          this.isneedDebit = true
          this.feedbackReport.debitUnit = 'NEW_BOX'
          this.feedbackReport.debitUnitI18n = this.boxText;
        } else {
          this.isneedDebit = false
          this.feedbackReport.debitNumber = 0
          this.feedbackReport.debitUnit = ''
          this.feedbackReport.debitUnitI18n = '';
        }
      }
    },
    showQuestionFun() {
      let that = this
      if (commonFun.isNotEmpty(that.feedback.questionReportNo)) {
        Message.warning(that.$t("storeFeedback.report.existsQuestion", [that.feedback.questionReportNo]));
        return false;
      } if (that.feedbackReport.auditStatus == "REPORT_FINISH" && commonFun.isEmpty(that.feedbackReport.question)) {
        that.$message({
          type: "error",
          message: that.$t("storeFeedback.report.byEmail"),
        });
      } else {
        that.questionDialogVisible = true
      }
      // let nodeList = this.nodeList
      // console.log(nodeList)
      // for(let a = 0,len=nodeList.length;a<len;a++){
      //     if(nodeList[a].nodeName == '最终处理结案' && nodeList[a].status == 'current'){
      //         this.$message({
      //             type: "error",
      //             message: this.$t("storeFeedback.report.byEmail"),
      //         });
      //         return;
      //     }
      // }
      // this.questionDialogVisible = true
    },
    HandleUrl(val) {
      return '/adminconsole/file/downloadByKey?key=' + val

    },
    debitNumberBlur(e) {
      this.feedbackReport.debitNumber = e.target.value
    },
    //文件上传
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = 'FC_TREATMENT';
        attachment.tsRecId = _this.feedbackReport.ttFeedbackReportId;
        attachment.tsReckindId = 'FEEDBACK_REPORT';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFcFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    getFcFiles: function () {
      let attachment = {};
      attachment.seq = 'FC_TREATMENT';
      attachment.tsRecId = this.feedbackReport.ttFeedbackReportId;
      attachment.tsReckindId = 'FEEDBACK_REPORT';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fcFileList = fileRes;
      })
    },
    deleteFcFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    saveFcRemark: function () {//FC备注修改
      let _this = this;
      reportApi.saveFcRemark(_this.feedbackReport).then((res) => {
        Message({ message: this.$t('common.operateSuccess'), type: "success" });
      }).catch((error) => {
        Message({ message: 'FC疑问备注保存失败', type: "error" });
      });
    }
  },
  watch: {
    dataChanged(newVal) {
      this.getData();
    }
  }
}

</script>
<style scoped  lang="scss">
.reportDetail_reportItem {
  .tableFile {
    margin-bottom: 20px;
  }
  .el-card,
  .el-message {
    border-radius: 0;
  }
}
</style>
<style  lang="scss">
.reportDetail_reportItem {
  .el-input__inner {
    width: 290px;
  }
  .hide .el-upload--picture-card {
    display: none;
  }
  .el-input-number--small {
    width: auto;
  }
  .el-input-number {
    width: auto;
  }
  .widthReset .el-form-item__content {
    width: 845px;
  }
  .colorBtn .el-button {
    background: #f8ab01 !important;
    color: #fff !important;
    border-color: #f8ab01 !important;
  }
  .autoWidth {
    .el-form-item.el-form-item--small {
      width: 100%;
      .el-form-item__content {
        width: 80%;
      }
    }
  }
  .reportDetailImgClass {
    .el-upload-list {
      display: flex;
      flex-wrap: wrap;
    }
    .el-input__inner {
      width: 100%;
    }
    .el-upload-list__item {
      position: relative;
      overflow: visible;
      margin-bottom: 45px;
      .el-input {
        position: absolute;
        bottom: -33px;
      }
      > div {
        height: 100%;
      }
    }
    .el-upload {
      margin-bottom: 30px;
    }
  }
}
</style>
